<script>
export default {
  name: 'CustomIcon',
  props: {
    group: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#000000',
    },
  },
  computed: {
    icon() {
      const icons = {
        classification: {
          POSITIVE: `<svg
               width="20"
               height="20"
               viewBox="0 0 20 20"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 d="M10.0085 1.66663C14.6085 1.66663 18.3335 5.39996 18.3335 9.99996C18.3335 14.6 14.6085 18.3333 10.0085 18.3333C5.40016 18.3333 1.66683 14.6 1.66683 9.99996C1.66683 5.39996 5.40016 1.66663 10.0085 1.66663ZM10.0002 16.6666C13.6835 16.6666 16.6668 13.6833 16.6668 9.99996C16.6668 6.31663 13.6835 3.33329 10.0002 3.33329C6.31683 3.33329 3.3335 6.31663 3.3335 9.99996C3.3335 13.6833 6.31683 16.6666 10.0002 16.6666ZM7.0835 9.16663C6.39183 9.16663 5.8335 8.60829 5.8335 7.91663C5.8335 7.22496 6.39183 6.66663 7.0835 6.66663C7.77516 6.66663 8.3335 7.22496 8.3335 7.91663C8.3335 8.60829 7.77516 9.16663 7.0835 9.16663ZM12.9168 9.16663C12.2252 9.16663 11.6668 8.60829 11.6668 7.91663C11.6668 7.22496 12.2252 6.66663 12.9168 6.66663C13.6085 6.66663 14.1668 7.22496 14.1668 7.91663C14.1668 8.60829 13.6085 9.16663 12.9168 9.16663ZM10.0002 14.5833C8.0585 14.5833 6.40849 13.3666 5.74183 11.6666H14.2585C13.5918 13.3666 11.9418 14.5833 10.0002 14.5833Z"
                 fill="${this.color}"
               />
               </svg>`,
          NEGATIVE: `<svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                d="M7.0835 9.16663C6.39314 9.16663 5.8335 8.60698 5.8335 7.91663C5.8335 7.22627 6.39314 6.66663 7.0835 6.66663C7.77385 6.66663 8.3335 7.22627 8.3335 7.91663C8.3335 8.60698 7.77385 9.16663 7.0835 9.16663Z"
                fill="${this.color}"
                />
                <path
                d="M12.9168 9.16663C12.2265 9.16663 11.6668 8.60698 11.6668 7.91663C11.6668 7.22627 12.2265 6.66663 12.9168 6.66663C13.6072 6.66663 14.1668 7.22627 14.1668 7.91663C14.1668 8.60698 13.6072 9.16663 12.9168 9.16663Z"
                fill="${this.color}"
                />
                <path
                d="M10.0002 11.6666C11.9418 11.6666 13.6002 12.875 14.2668 14.5833H12.8752C12.3002 13.5916 11.2335 12.9166 10.0002 12.9166C8.76683 12.9166 7.7085 13.5916 7.12516 14.5833H5.73349C6.40016 12.875 8.0585 11.6666 10.0002 11.6666ZM10.0085 1.66663C14.6085 1.66663 18.3335 5.39996 18.3335 9.99996C18.3335 14.6 14.6085 18.3333 10.0085 18.3333C5.40016 18.3333 1.66683 14.6 1.66683 9.99996C1.66683 5.39996 5.40016 1.66663 10.0085 1.66663ZM10.0002 16.6666C13.6835 16.6666 16.6668 13.6833 16.6668 9.99996C16.6668 6.31663 13.6835 3.33329 10.0002 3.33329C6.31683 3.33329 3.3335 6.31663 3.3335 9.99996C3.3335 13.6833 6.31683 16.6666 10.0002 16.6666Z"
                fill="${this.color}"
                />
            </svg>`,
          NEUTRAL: `<svg
               width="20"
               height="20"
               viewBox="0 0 20 20"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
             >
               <path
                 d="M12.5002 11.6666H7.50016V12.9166H12.5002V11.6666Z"
                 fill="${this.color}"
               />
               <path
                 d="M7.0835 9.16663C6.39314 9.16663 5.8335 8.60698 5.8335 7.91663C5.8335 7.22627 6.39314 6.66663 7.0835 6.66663C7.77385 6.66663 8.3335 7.22627 8.3335 7.91663C8.3335 8.60698 7.77385 9.16663 7.0835 9.16663Z"
                 fill="${this.color}"
               />
               <path
                 d="M12.9168 9.16663C12.2265 9.16663 11.6668 8.60698 11.6668 7.91663C11.6668 7.22627 12.2265 6.66663 12.9168 6.66663C13.6072 6.66663 14.1668 7.22627 14.1668 7.91663C14.1668 8.60698 13.6072 9.16663 12.9168 9.16663Z"
                 fill="${this.color}"
               />
               <path
                 d="M10.0085 1.66663C14.6085 1.66663 18.3335 5.39996 18.3335 9.99996C18.3335 14.6 14.6085 18.3333 10.0085 18.3333C5.40016 18.3333 1.66683 14.6 1.66683 9.99996C1.66683 5.39996 5.40016 1.66663 10.0085 1.66663ZM10.0002 16.6666C13.6835 16.6666 16.6668 13.6833 16.6668 9.99996C16.6668 6.31663 13.6835 3.33329 10.0002 3.33329C6.31683 3.33329 3.3335 6.31663 3.3335 9.99996C3.3335 13.6833 6.31683 16.6666 10.0002 16.6666Z"
                 fill="${this.color}"
               />
             </svg>`,
          IRONY: `<svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.0835 10.8334C6.39314 10.8334 5.8335 11.393 5.8335 12.0834C5.8335 12.7737 6.39314 13.3334 7.0835 13.3334C7.77385 13.3334 8.3335 12.7737 8.3335 12.0834C8.3335 11.393 7.77385 10.8334 7.0835 10.8334Z"
              fill="${this.color}"
            />
            <path
              d="M12.9168 10.8334C12.2265 10.8334 11.6668 11.393 11.6668 12.0834C11.6668 12.7737 12.2265 13.3334 12.9168 13.3334C13.6072 13.3334 14.1668 12.7737 14.1668 12.0834C14.1668 11.393 13.6072 10.8334 12.9168 10.8334Z"
              fill="${this.color}"
            />
            <path
              d="M10.0002 6.66671C11.2335 6.66671 12.2918 7.34171 12.8752 8.33337H14.2668C13.6002 6.62504 11.9418 5.41671 10.0002 5.41671C8.0585 5.41671 6.40016 6.62504 5.73349 8.33337H7.12516C7.7085 7.34171 8.76683 6.66671 10.0002 6.66671ZM10.0085 18.3334C14.6085 18.3334 18.3335 14.6 18.3335 10C18.3335 5.40004 14.6085 1.66671 10.0085 1.66671C5.40016 1.66671 1.66683 5.40004 1.66683 10C1.66683 14.6 5.40016 18.3334 10.0085 18.3334ZM10.0002 3.33337C13.6835 3.33337 16.6668 6.31671 16.6668 10C16.6668 13.6834 13.6835 16.6667 10.0002 16.6667C6.31683 16.6667 3.3335 13.6834 3.3335 10C3.3335 6.31671 6.31683 3.33337 10.0002 3.33337Z"
              fill="${this.color}"
            />
          </svg>`,
          AI_REPLY: `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.834 7.50016L16.8757 5.2085L19.1673 4.16683L16.8757 3.12516L15.834 0.833496L14.7923 3.12516L12.5007 4.16683L14.7923 5.2085L15.834 7.50016Z" fill="#60646C"/>
              <path d="M15.834 12.5002L14.7923 14.7918L12.5007 15.8335L14.7923 16.8752L15.834 19.1668L16.8757 16.8752L19.1673 15.8335L16.8757 14.7918L15.834 12.5002Z" fill="#60646C"/>
              <path d="M9.58398 7.91683L7.50065 3.3335L5.41732 7.91683L0.833984 10.0002L5.41732 12.0835L7.50065 16.6668L9.58398 12.0835L14.1673 10.0002L9.58398 7.91683ZM8.32565 10.8252L7.50065 12.6418L6.67565 10.8252L4.85898 10.0002L6.67565 9.17516L7.50065 7.3585L8.32565 9.17516L10.1423 10.0002L8.32565 10.8252Z" fill="#60646C"/>
            </svg>
          `,
          SPAM: `<svg
             width="20"
             height="20"
             viewBox="0 0 20 20"
             fill="none"
             xmlns="http://www.w3.org/2000/svg"
           >
             <path
               d="M3.33317 7.91671V6.25004C3.33317 5.33337 4.08317 4.58337 4.99984 4.58337H7.49984C7.49984 3.20004 8.6165 2.08337 9.99984 2.08337C11.3832 2.08337 12.4998 3.20004 12.4998 4.58337H14.9998C15.9165 4.58337 16.6665 5.33337 16.6665 6.25004V7.91671C18.0498 7.91671 19.1665 9.03337 19.1665 10.4167C19.1665 11.8 18.0498 12.9167 16.6665 12.9167V16.25C16.6665 17.1667 15.9165 17.9167 14.9998 17.9167H4.99984C4.08317 17.9167 3.33317 17.1667 3.33317 16.25V12.9167C1.94984 12.9167 0.833172 11.8 0.833172 10.4167C0.833172 9.03337 1.94984 7.91671 3.33317 7.91671ZM4.99984 16.25H14.9998V6.25004H4.99984V16.25ZM12.4998 11.25C13.1915 11.25 13.7498 10.6917 13.7498 10C13.7498 9.30837 13.1915 8.75004 12.4998 8.75004C11.8082 8.75004 11.2498 9.30837 11.2498 10C11.2498 10.6917 11.8082 11.25 12.4998 11.25ZM6.24984 10C6.24984 10.6917 6.80817 11.25 7.49984 11.25C8.1915 11.25 8.74984 10.6917 8.74984 10C8.74984 9.30837 8.1915 8.75004 7.49984 8.75004C6.80817 8.75004 6.24984 9.30837 6.24984 10ZM13.3332 12.9167H6.6665V14.5834H13.3332V12.9167Z"
               fill="${this.color}"
             />
           </svg>`,
        },
        metadata: {
          PURCHASE_INTENTION: `
            <svg width="20" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.0007 3.99984H10.334C10.334 2.15817 8.84232 0.666504 7.00065 0.666504C5.15898 0.666504 3.66732 2.15817 3.66732 3.99984H2.00065C1.08398 3.99984 0.333984 4.74984 0.333984 5.6665V15.6665C0.333984 16.5832 1.08398 17.3332 2.00065 17.3332H12.0007C12.9173 17.3332 13.6673 16.5832 13.6673 15.6665V5.6665C13.6673 4.74984 12.9173 3.99984 12.0007 3.99984ZM7.00065 2.33317C7.91732 2.33317 8.66732 3.08317 8.66732 3.99984H5.33398C5.33398 3.08317 6.08398 2.33317 7.00065 2.33317ZM12.0007 15.6665H2.00065V5.6665H3.66732V7.33317C3.66732 7.7915 4.04232 8.1665 4.50065 8.1665C4.95898 8.1665 5.33398 7.7915 5.33398 7.33317V5.6665H8.66732V7.33317C8.66732 7.7915 9.04232 8.1665 9.50065 8.1665C9.95898 8.1665 10.334 7.7915 10.334 7.33317V5.6665H12.0007V15.6665Z" fill="#874BE7"/>
            </svg>
          `,
        },
        commentType: {
          FEED: `<svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.8402 8.51037L9.48183 1.15203C9.17349 0.843701 8.74849 0.668701 8.30683 0.668701H2.33183C1.41516 0.668701 0.665161 1.4187 0.665161 2.33537V8.31037C0.665161 8.75203 0.840161 9.17703 1.15683 9.48537L8.51516 16.8437C9.16516 17.4937 10.2235 17.4937 10.8735 16.8437L16.8485 10.8687C17.4985 10.2187 17.4985 9.1687 16.8402 8.51037ZM9.69016 15.6687L2.33183 8.31037V2.33537H8.30683L15.6652 9.6937L9.69016 15.6687Z"
              fill="${this.color}"
            />
            <path
              d="M4.41516 5.6687C5.10552 5.6687 5.66516 5.10906 5.66516 4.4187C5.66516 3.72835 5.10552 3.1687 4.41516 3.1687C3.72481 3.1687 3.16516 3.72835 3.16516 4.4187C3.16516 5.10906 3.72481 5.6687 4.41516 5.6687Z"
              fill="${this.color}"
            />
          </svg>`,
          MENTION: `<svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.99996 0.666748C4.39996 0.666748 0.666626 4.40008 0.666626 9.00008C0.666626 13.6001 4.39996 17.3334 8.99996 17.3334H13.1666V15.6667H8.99996C5.38329 15.6667 2.33329 12.6167 2.33329 9.00008C2.33329 5.38341 5.38329 2.33341 8.99996 2.33341C12.6166 2.33341 15.6666 5.38341 15.6666 9.00008V10.1917C15.6666 10.8501 15.075 11.5001 14.4166 11.5001C13.7583 11.5001 13.1666 10.8501 13.1666 10.1917V9.00008C13.1666 6.70008 11.3 4.83342 8.99996 4.83342C6.69996 4.83342 4.83329 6.70008 4.83329 9.00008C4.83329 11.3001 6.69996 13.1667 8.99996 13.1667C10.15 13.1667 11.2 12.7001 11.95 11.9417C12.4916 12.6834 13.425 13.1667 14.4166 13.1667C16.0583 13.1667 17.3333 11.8334 17.3333 10.1917V9.00008C17.3333 4.40008 13.6 0.666748 8.99996 0.666748ZM8.99996 11.5001C7.61663 11.5001 6.49996 10.3834 6.49996 9.00008C6.49996 7.61675 7.61663 6.50008 8.99996 6.50008C10.3833 6.50008 11.5 7.61675 11.5 9.00008C11.5 10.3834 10.3833 11.5001 8.99996 11.5001Z"
              fill="${this.color}"
            />
          </svg>`,
          AD: `
          <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.32497 7.08333C3.4333 6.59167 2.82497 6.08333 2.82497 5.29167C2.82497 4.38333 3.66663 3.75 5.07497 3.75C6.5583 3.75 7.1083 4.45833 7.1583 5.5H8.99997C8.94163 4.06667 8.06663 2.75 6.32497 2.325V0.5H3.82497V2.3C2.2083 2.65 0.908301 3.7 0.908301 5.30833C0.908301 7.23333 2.49997 8.19167 4.82497 8.75C6.9083 9.25 7.32497 9.98333 7.32497 10.7583C7.32497 11.3333 6.91663 12.25 5.07497 12.25C3.3583 12.25 2.6833 11.4833 2.59163 10.5H0.758301C0.858301 12.325 2.22497 13.35 3.82497 13.6917V15.5H6.32497V13.7083C7.94997 13.4 9.24163 12.4583 9.24163 10.75C9.24163 8.38333 7.21663 7.575 5.32497 7.08333Z"
              fill="${this.color}"
            />
          </svg>
        `,
          REELS: `<svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.8402 8.51037L9.48183 1.15203C9.17349 0.843701 8.74849 0.668701 8.30683 0.668701H2.33183C1.41516 0.668701 0.665161 1.4187 0.665161 2.33537V8.31037C0.665161 8.75203 0.840161 9.17703 1.15683 9.48537L8.51516 16.8437C9.16516 17.4937 10.2235 17.4937 10.8735 16.8437L16.8485 10.8687C17.4985 10.2187 17.4985 9.1687 16.8402 8.51037ZM9.69016 15.6687L2.33183 8.31037V2.33537H8.30683L15.6652 9.6937L9.69016 15.6687Z"
              fill="${this.color}"
            />
            <path
              d="M4.41516 5.6687C5.10552 5.6687 5.66516 5.10906 5.66516 4.4187C5.66516 3.72835 5.10552 3.1687 4.41516 3.1687C3.72481 3.1687 3.16516 3.72835 3.16516 4.4187C3.16516 5.10906 3.72481 5.6687 4.41516 5.6687Z"
              fill="${this.color}"
            />
          </svg>`,
        },
        sourceType: {
          FACEBOOK: `
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10C20 4.4772 15.5228 0 10 0Z"
                fill="${this.color}"
              />
            </svg>
        `,
          INSTAGRAM: `
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
              clip-path="url(#clip0_225_289)">
                <path
                  d="M10 1.80078C12.6719 1.80078 12.9883 1.8125 14.0391 1.85937C15.0156 1.90234 15.543 2.06641 15.8945 2.20313C16.3594 2.38281 16.6953 2.60156 17.043 2.94922C17.3945 3.30078 17.6094 3.63281 17.7891 4.09766C17.9258 4.44922 18.0898 4.98047 18.1328 5.95312C18.1797 7.00781 18.1914 7.32422 18.1914 9.99219C18.1914 12.6641 18.1797 12.9805 18.1328 14.0313C18.0898 15.0078 17.9258 15.5352 17.7891 15.8867C17.6094 16.3516 17.3906 16.6875 17.043 17.0352C16.6914 17.3867 16.3594 17.6016 15.8945 17.7813C15.543 17.918 15.0117 18.082 14.0391 18.125C12.9844 18.1719 12.668 18.1836 10 18.1836C7.32813 18.1836 7.01172 18.1719 5.96094 18.125C4.98438 18.082 4.45703 17.918 4.10547 17.7813C3.64063 17.6016 3.30469 17.3828 2.95703 17.0352C2.60547 16.6836 2.39063 16.3516 2.21094 15.8867C2.07422 15.5352 1.91016 15.0039 1.86719 14.0313C1.82031 12.9766 1.80859 12.6602 1.80859 9.99219C1.80859 7.32031 1.82031 7.00391 1.86719 5.95312C1.91016 4.97656 2.07422 4.44922 2.21094 4.09766C2.39063 3.63281 2.60938 3.29688 2.95703 2.94922C3.30859 2.59766 3.64063 2.38281 4.10547 2.20313C4.45703 2.06641 4.98828 1.90234 5.96094 1.85937C7.01172 1.8125 7.32813 1.80078 10 1.80078ZM10 0C7.28516 0 6.94531 0.0117187 5.87891 0.0585938C4.81641 0.105469 4.08594 0.277344 3.45313 0.523438C2.79297 0.78125 2.23438 1.12109 1.67969 1.67969C1.12109 2.23438 0.78125 2.79297 0.523438 3.44922C0.277344 4.08594 0.105469 4.8125 0.0585938 5.875C0.0117188 6.94531 0 7.28516 0 10C0 12.7148 0.0117188 13.0547 0.0585938 14.1211C0.105469 15.1836 0.277344 15.9141 0.523438 16.5469C0.78125 17.207 1.12109 17.7656 1.67969 18.3203C2.23438 18.875 2.79297 19.2188 3.44922 19.4727C4.08594 19.7188 4.8125 19.8906 5.875 19.9375C6.94141 19.9844 7.28125 19.9961 9.99609 19.9961C12.7109 19.9961 13.0508 19.9844 14.1172 19.9375C15.1797 19.8906 15.9102 19.7188 16.543 19.4727C17.1992 19.2188 17.7578 18.875 18.3125 18.3203C18.8672 17.7656 19.2109 17.207 19.4648 16.5508C19.7109 15.9141 19.8828 15.1875 19.9297 14.125C19.9766 13.0586 19.9883 12.7188 19.9883 10.0039C19.9883 7.28906 19.9766 6.94922 19.9297 5.88281C19.8828 4.82031 19.7109 4.08984 19.4648 3.45703C19.2188 2.79297 18.8789 2.23438 18.3203 1.67969C17.7656 1.125 17.207 0.78125 16.5508 0.527344C15.9141 0.28125 15.1875 0.109375 14.125 0.0625C13.0547 0.0117188 12.7148 0 10 0Z"
                  fill="${this.color}"
                />
                <path
                  d="M10 4.86328C7.16406 4.86328 4.86328 7.16406 4.86328 10C4.86328 12.8359 7.16406 15.1367 10 15.1367C12.8359 15.1367 15.1367 12.8359 15.1367 10C15.1367 7.16406 12.8359 4.86328 10 4.86328ZM10 13.332C8.16016 13.332 6.66797 11.8398 6.66797 10C6.66797 8.16016 8.16016 6.66797 10 6.66797C11.8398 6.66797 13.332 8.16016 13.332 10C13.332 11.8398 11.8398 13.332 10 13.332Z"
                  fill="${this.color}"
                />
                <path
                  d="M16.5391 4.66016C16.5391 5.32422 16 5.85938 15.3398 5.85938C14.6758 5.85938 14.1406 5.32031 14.1406 4.66016C14.1406 3.99609 14.6797 3.46094 15.3398 3.46094C16 3.46094 16.5391 4 16.5391 4.66016Z"
                  fill="${this.color}"
                />
              </g>
              <defs>
                <clipPath id="clip0_225_289">
                  <rect width="20" height="20" fill="white"/>
                </clipPath>
              </defs>
          </svg>
        `,
        },
        general: {
          FILTER: `
            <svg
              width="13"
              height="16"
              viewBox="0 0 13 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.00016 0.5L12.3335 3.825H9.8335V9.66667H8.16683V3.825H5.66683L9.00016 0.5ZM3.16683 12.175V6.33333H4.8335V12.175H7.3335L4.00016 15.5L0.66683 12.175H3.16683Z"
                fill="${this.color}"
              />
          </svg>
        `,
          LOADING: `
              <svg
                class="animate-spin h-5 w-5 text-blue-500"
                viewBox="0 0 24 24"
                fill="none"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                />
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v2.5a5.5 5.5 0 00-5.5 5.5H4z"
                />
            </svg>
          `,
          DISMISS: `<svg
              width="16"
              height="16"
              fill="none"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m4.397 4.554.073-.084a.75.75 0 0 1 .976-.073l.084.073L12 10.939l6.47-6.47a.75.75 0 1 1 1.06 1.061L13.061 12l6.47 6.47a.75.75 0 0 1 .072.976l-.073.084a.75.75 0 0 1-.976.073l-.084-.073L12 13.061l-6.47 6.47a.75.75 0 0 1-1.06-1.061L10.939 12l-6.47-6.47a.75.75 0 0 1-.072-.976l.073-.084-.073.084Z"
                fill="currentColor"
              >
              </path>
            </svg>`,
        },
        platform: {
          FACEBOOK: `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_366_9706)">
              <path d="M20 10C20 4.4772 15.5228 0 10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10H20Z" fill="#0866FF"/>
              <path d="M13.9163 13.0559L14.4775 9.9999H11.2111V8.9191C11.2111 7.3043 11.8447 6.6831 13.4843 6.6831C13.9935 6.6831 14.4035 6.6955 14.6395 6.7203V3.9503C14.1923 3.8259 13.0991 3.7019 12.4655 3.7019C9.12388 3.7019 7.58348 5.2795 7.58348 8.6831V9.9999H5.52148V13.0559H7.58348V19.7055C8.35708 19.8975 9.16628 19.9999 9.99908 19.9999C10.4091 19.9999 10.8135 19.9747 11.2107 19.9267V13.0559H13.9159H13.9163Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_366_9706">
              <rect width="20" height="20" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          `,
          INSTAGRAM: `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_366_9701)">
              <path d="M10 1.80078C12.6719 1.80078 12.9883 1.8125 14.0391 1.85937C15.0156 1.90234 15.543 2.06641 15.8945 2.20313C16.3594 2.38281 16.6953 2.60156 17.043 2.94922C17.3945 3.30078 17.6094 3.63281 17.7891 4.09766C17.9258 4.44922 18.0898 4.98047 18.1328 5.95312C18.1797 7.00781 18.1914 7.32422 18.1914 9.99219C18.1914 12.6641 18.1797 12.9805 18.1328 14.0313C18.0898 15.0078 17.9258 15.5352 17.7891 15.8867C17.6094 16.3516 17.3906 16.6875 17.043 17.0352C16.6914 17.3867 16.3594 17.6016 15.8945 17.7813C15.543 17.918 15.0117 18.082 14.0391 18.125C12.9844 18.1719 12.668 18.1836 10 18.1836C7.32813 18.1836 7.01172 18.1719 5.96094 18.125C4.98438 18.082 4.45703 17.918 4.10547 17.7813C3.64063 17.6016 3.30469 17.3828 2.95703 17.0352C2.60547 16.6836 2.39063 16.3516 2.21094 15.8867C2.07422 15.5352 1.91016 15.0039 1.86719 14.0313C1.82031 12.9766 1.80859 12.6602 1.80859 9.99219C1.80859 7.32031 1.82031 7.00391 1.86719 5.95312C1.91016 4.97656 2.07422 4.44922 2.21094 4.09766C2.39063 3.63281 2.60938 3.29688 2.95703 2.94922C3.30859 2.59766 3.64063 2.38281 4.10547 2.20313C4.45703 2.06641 4.98828 1.90234 5.96094 1.85937C7.01172 1.8125 7.32813 1.80078 10 1.80078ZM10 0C7.28516 0 6.94531 0.0117187 5.87891 0.0585938C4.81641 0.105469 4.08594 0.277344 3.45313 0.523438C2.79297 0.78125 2.23438 1.12109 1.67969 1.67969C1.12109 2.23438 0.78125 2.79297 0.523438 3.44922C0.277344 4.08594 0.105469 4.8125 0.0585938 5.875C0.0117188 6.94531 0 7.28516 0 10C0 12.7148 0.0117188 13.0547 0.0585938 14.1211C0.105469 15.1836 0.277344 15.9141 0.523438 16.5469C0.78125 17.207 1.12109 17.7656 1.67969 18.3203C2.23438 18.875 2.79297 19.2188 3.44922 19.4727C4.08594 19.7188 4.8125 19.8906 5.875 19.9375C6.94141 19.9844 7.28125 19.9961 9.99609 19.9961C12.7109 19.9961 13.0508 19.9844 14.1172 19.9375C15.1797 19.8906 15.9102 19.7188 16.543 19.4727C17.1992 19.2188 17.7578 18.875 18.3125 18.3203C18.8672 17.7656 19.2109 17.207 19.4648 16.5508C19.7109 15.9141 19.8828 15.1875 19.9297 14.125C19.9766 13.0586 19.9883 12.7188 19.9883 10.0039C19.9883 7.28906 19.9766 6.94922 19.9297 5.88281C19.8828 4.82031 19.7109 4.08984 19.4648 3.45703C19.2188 2.79297 18.8789 2.23438 18.3203 1.67969C17.7656 1.125 17.207 0.78125 16.5508 0.527344C15.9141 0.28125 15.1875 0.109375 14.125 0.0625C13.0547 0.0117188 12.7148 0 10 0Z" fill="#000100"/>
              <path d="M10 4.86328C7.16406 4.86328 4.86328 7.16406 4.86328 10C4.86328 12.8359 7.16406 15.1367 10 15.1367C12.8359 15.1367 15.1367 12.8359 15.1367 10C15.1367 7.16406 12.8359 4.86328 10 4.86328ZM10 13.332C8.16016 13.332 6.66797 11.8398 6.66797 10C6.66797 8.16016 8.16016 6.66797 10 6.66797C11.8398 6.66797 13.332 8.16016 13.332 10C13.332 11.8398 11.8398 13.332 10 13.332Z" fill="#000100"/>
              <path d="M16.5391 4.66016C16.5391 5.32422 16 5.85938 15.3398 5.85938C14.6758 5.85938 14.1406 5.32032 14.1406 4.66016C14.1406 3.99609 14.6797 3.46094 15.3398 3.46094C16 3.46094 16.5391 4 16.5391 4.66016Z" fill="#000100"/>
              </g>
              <defs>
              <clipPath id="clip0_366_9701">
              <rect width="20" height="20" fill="white"/>
              </clipPath>
              </defs>
            </svg>
          `,
        },
      };

      return icons[this.group]?.[this.name] || '<!-- Ícone não encontrado -->';
    },
  },
};
</script>

<template>
  <div v-html="icon" />
</template>
